import React, { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import InstallmentCalculation from "../../components/InstallmentCalculation/InstallmentCalculation";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import CartItem from "../../components/CartItem/CartItem";
import { addToCart, removeFromCart, decreaseCountFromCart } from "../../Redux/Actions";
import { Config } from "../../Config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../components/Spinner/Spinner";
import emptyCartImage from "../../assets/images/emptyCart.svg";
import "./Cart.scss";
import "./Responsive.scss";

const Cart = (props) => {
  const [address, setAddress] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [payType, setPayType] = useState(true);
  const [creditBalance, setCreditBalance] = React.useState("");
  const [cashPay, setCashPay] = React.useState("");
  const [tblData, setTblData] = React.useState([]);
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  useEffect(() => {
    Config.pageUp();
    if (user.length <= 0) {
      props.history.push("/login");
    }
    if (user[0] !== undefined && user[0]?.address) {
      setAddress(user[0]?.address);
    }
  }, [user.length <= 0]);

  const getTotalPrice = () => {
    let totalPrice = cart.map((item) => item.unitPrice * item.count);
    return totalPrice.reduce((acc, curr) => acc + curr, 0);
  };

  const badgeHandler = () => {
    let badge = cart.map((item) => item.count);
    return badge.reduce((acc, curr) => acc + curr, 0);
  };

  const breadCrumbData = [
    { title: "خانه", link: "/" },
    { title: "سبد خرید", link: "/cart" },
  ];

  const cartCountPlus = (product) => {
    console.log("product", product);
    cartAddRemoveHandler("update", product, product.orderDetailId, product.count + 1);
    // dispatch(addToCart(product));
  };

  const cartCountMinus = (product) => {
    cartAddRemoveHandler("delete", product, product.orderDetailId, product.count - 1);
    // dispatch(decreaseCountFromCart(product));
  };

  const cartAddRemoveHandler = (action, item, orderDetailId, count) => {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

    let raw = JSON.stringify({
      Id: orderDetailId,
      Count: count,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(Config.apiPath + "/orders/CommandOrderDetail", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          if (action === "delete") {
            dispatch(decreaseCountFromCart(item));
            toast.success(<div>{result.messages}</div>);
          } else if (action === "update") {
            dispatch(addToCart(item));
          }
        } else {
          toast.error(<div>{result.messages}</div>);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const deleteCartHandler = (product) => {
    cartRemoveHandler(product, product.orderDetailId);
  };

  const cartRemoveHandler = (product, orderDetailId) => {
    axios
      .get(`/orders/DeleteOrderDetail/${orderDetailId}`, {
        headers: {
          Authorization: "Bearer " + user[0]?.token,
        },
      })
      .then((result) => {
        if (result.data.status === 200) {
          toast.success(<div>{result.data.messages}</div>);
          dispatch(removeFromCart(product));
        } else {
          toast.error(<div>{result.data.messages}</div>);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeAddressHandler = () => {
    props.history.push({
      pathname: "/changeAddress",
      state: { chooseAddress: true },
    });
  };

  const paymentHandler = (ic) => {
    setShowSpinner(true);
    // if (user[0]?.activeMapId === undefined) {
    //   toast.error("آدرس انتخاب نشده است!");
    //   return false;
    // }
    if (cart.length > 0) {
      // return;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + user[0]?.token);

      let raw = JSON.stringify({
        AddressId: null,
        Price: getTotalPrice(),
        isCash: ic,
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/Payment/Pay", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            setShowSpinner(false);
            window.location.replace(result.data.link);
            // props.history.push(`${result.data.link}`);
          }
        })
        .catch((error) => {
          // console.log("error", error);
          setShowSpinner(false);
        });
    }
  };

  const installMentActionHandler = () => {
    setPayType(!payType);
  };
  const installmentCalculateHandler = () => {
    setShowSpinner(true);
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    user[0]?.token && myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);
    let raw = JSON.stringify({
      ProductName: "Iphone13",
      Store: "fcae15d0-edb5-455a-b4df-013c61cfa50a",
      ProductCode: "23",
      // "Price": Number(productPrice.replace(/,/g, '')),
      Price: getTotalPrice(),
      CreditBalance: Number(creditBalance.replace(/,/g, "")),
      CashPay: Number(cashPay.replace(/,/g, "")),
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/Home/CalculateAghsat", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          setTblData(result.data);
          setShowSpinner(false);
        } else {
          toast.error(<div>{result.messages}</div>);
          setShowSpinner(false);
        }
      })
      .catch((error) => {
        // console.log("error", error);
        setShowSpinner(false);
      });
  };
  const CashPayHandler = (e) => {
    setCashPay(e.target.value);
  };
  const CreditBalanceHandler = (e) => {
    setCreditBalance(e.target.value);
  };

  return (
    <section className="cartWrapper mobile">
      <Helmet>
        {/* <title>ایران رگالو | سبد خرید</title> */}
        <title>{Config.helmetTitle} | سبد خرید</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <BreadCrumb breadCrumbData={breadCrumbData} />
      <div className="cartContents">
        {!payType && <InstallmentCalculation tblData={tblData} />}
        {cart.length > 0 ? (
          <div className="desktop">
            <div className="cartItemsBox">
              <div className="cartItemBoxHeader">
                <p className="title">
                  <FaCheckCircle /> سبد خرید شما
                </p>
              </div>
              <div className="cartItemHeader">
                <p className="cartItemImage">تصویر</p>
                <div className="headerBox">
                  <p className="title">عنوان محصول</p>
                  <p className="amount">قیمت(ریال)</p>
                  <p className="amountCount">تعداد</p>
                  <p className="totalAmount">مجموع(ریال)</p>
                </div>
              </div>
              <CartItem
                cartData={cart}
                deleteCartItemHandler={deleteCartHandler}
                cartCountPlus={cartCountPlus}
                cartCountMinus={cartCountMinus}
              />
            </div>
            <div className="summaryCart">
              <div className="summaryHeader">
                <p className="summaryheaderTitle">قیمت محصولات ({badgeHandler()})</p>
                <p className="summaryHeaderTotalAmount">{Config.separate(getTotalPrice())} ریال</p>
              </div>
              <div className="summaryItems">
                <p className="title">جمع سبد خرید</p>
                <p className="totalAmount">{Config.separate(getTotalPrice())} ریال</p>
              </div>
              <div className="summaryItems address">
                <p className="addressTitle">
                  آدرس
                  <span className="changeAddress" onClick={changeAddressHandler}>
                    {address !== "" ? "(تغییر آدرس)" : "(ثبت آدرس)"}
                  </span>
                </p>
                {address !== "" ? <p className="address">{address}</p> : <p className="address">آدرسی ثبت نشده است!</p>}
              </div>
              {/* <div className="summaryItems col">
                <div className="summaryType">
                  <span
                    className={payType ? "installmentAction active" : "installmentAction"}
                    onClick={installMentActionHandler}
                  >
                    نقد
                  </span>
                  <span
                    className={!payType ? "installmentAction active" : "installmentAction"}
                    onClick={installMentActionHandler}
                  >
                    اقساط
                  </span>
                </div>
                {!payType && (
                  <div className="summaryInputs">
                    <div
                      className="formGroup"
                      data-tooltip="مبلغ قابل استفاده کارت اعتباری"
                      data-tooltip-location="top"
                    >
                      <input
                        type="text"
                        className="InstallmentCalculationInput pl"
                        value={Config.separate(creditBalance)}
                        onChange={(e) => CreditBalanceHandler(e)}
                        placeholder="مبلغ قابل استفاده کارت اعتباری"
                      />
                    </div>
                    <div
                      className="formGroup"
                      data-tooltip="پیش پرداخت نقدی به ریال در صورت تمایل"
                      data-tooltip-location="top"
                    >
                      <input
                        type="text"
                        className="InstallmentCalculationInput pl"
                        value={Config.separate(cashPay)}
                        onChange={(e) => CashPayHandler(e)}
                        placeholder="پیش پرداخت نقدی به ریال در صورت تمایل"
                      />
                    </div>
                  </div>
                )}
              </div> */}
              <div className="summaryItems payType">
                <p className="title">نحوه ارسال</p>
                <div className="payTypeWrapper">
                  <div className="inputWrapper invalidCartInput">
                    <label
                    // onClick={(e) => {
                    //   e.target.nextSibling.click();
                    // }}
                    >
                      ارسال پستی
                    </label>
                    <input type="radio" name="paytype" />
                  </div>
                  <div className="inputWrapper">
                    <label
                    // onClick={(e) => {
                    //   e.target.nextSibling.click();
                    // }}
                    >
                      تحویل در محل
                    </label>
                    <input type="radio" name="paytype" checked />
                  </div>
                </div>
              </div>
              <div className="summaryItems">
                <p className="title">مبلغ قابل پرداخت</p>
                <p className="totalAmount">{Config.separate(getTotalPrice())} ریال</p>
              </div>
              <div className="summaryItems">
                {/* {payType ? ( */}
                <button
                  className={`${user ? "btnSubmitCart actived" : "btnSubmitCart"} ${showSpinner ? "invalidInput" : ""}`}
                  onClick={() => paymentHandler(false)}
                >
                  {showSpinner ? <Spinner color="#fff" /> : "ورود به صفحه پرداخت"}
                </button>
                <button
                  className={`${user ? "btnSubmitCart actived" : "btnSubmitCart"} ${showSpinner ? "invalidInput" : ""}`}
                  onClick={() => paymentHandler(true)}
                >
                  {showSpinner ? <Spinner color="#fff" /> : "پرداخت نقدی"}
                </button>
                {/* // ) : ( */}
                {/* //   <button */}
                {/* //     className={user ? "btnSubmitCart actived" : "btnSubmitCart"}
                //     onClick={installmentCalculateHandler}
                //   > */}
                {/* //     {showSpinner ? <Spinner color="#fff" /> : "محاسبه اقساط"}
                //   </button>
                // )} */}
              </div>
            </div>
          </div>
        ) : (
          <div className="desktop">
            <div className="emptyCart">
              <img src={emptyCartImage} alt="empty cart" className="emptyCartImage" />
              <p className="emptyTitle">سبد خرید شما خالی است!</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default React.memo(Cart);
